import FaqEditContainer from '../../containers/admin/FaqEditContainer';

export default function FaqEditPage({ mode = 'create' }) {
    return (
        <FaqEditContainer mode={mode} />
    );
}
